import React, { useEffect } from "react";
import "./transferNoteDetails.css";

// components imports
// apis imports
// library imports
import Table from "@mui/material/Table";
import TableCell from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import TableBody from "@mui/material/TableBody";
import Modal from "@mui/material/Modal";
import { useSelector } from "react-redux";
import { convertTime } from "../../../../../helpers/helpers";
import { useTranslation } from "react-i18next";

const TransferNoteDetails = ({ open, setOpen }) => {
  const { t } = useTranslation(["inventory", "common"]);
  const user = useSelector((state) => state.user);
  return (
    <>
      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="transfer_note_details_modal_title"
        aria-describedby="transfer_note_details_modal_description"
      >
        <div className="details_container_modal">
          <h3 className="details_container_modal_title">
            {t("transferNotes.detailsFor", { reference: open?.reference_no ?? "-" })}
          </h3>

          <div className="details_container_modal_body">
            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">{t("transferNotes.dateColon")}</div>
              <div className="custabscreen__rdverttable_data">
                {convertTime(open?.created_at)}
              </div>
            </div>

            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">
                {t("transferNotes.referenceNumberColon")}
              </div>
              <div className="custabscreen__rdverttable_data">
                {open?.reference_no ?? "-"}
              </div>
            </div>

            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">
                {t("transferNotes.fromWarehouseColon")}
              </div>
              <div className="custabscreen__rdverttable_data">
                {open?.from_warehouse?.name ?? "-"}
              </div>
            </div>

            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">
                {t("transferNotes.toWarehouseColon")}
              </div>
              <div className="custabscreen__rdverttable_data">
                {open?.to_warehouse?.name ?? "-"}
              </div>
            </div>

            <div className="custabscreen__rdverttable_row">
              <div className="custabscreen__rdverttable_heading">
                {t("transferNotes.createdByColon")}
              </div>
              <div className="custabscreen__rdverttable_data">
                {user?.username ?? "-"}
              </div>
            </div>
          </div>
          <div className="details_container_modal_body">
            <TableContainer>
              <Table
                sx={{ minWidth: 650 }}
                size="small"
                aria-label={t("transferNotes.aDenseTable")}
              >
                <TableHead>
                  <TableRow>
                    <TableCell align="center">
                      <strong>{t("transferNotes.productCode")}</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>{t("transferNotes.name")}</strong>
                    </TableCell>
                    <TableCell align="center">
                      <strong>{t("transferNotes.quantity")}</strong>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {open?.transfer_note_details?.map((transferDetail, index) => (
                    <>
                      <TableRow key={index}>
                        <TableCell
                          classes={{ padding: "0px 16px" }}
                          align="center"
                        >
                          {transferDetail?.id ?? "-"}
                        </TableCell>
                        <TableCell
                          classes={{ padding: "0px 16px" }}
                          align="center"
                        >
                          {transferDetail?.product?.full_name ?? "-"}
                        </TableCell>

                        <TableCell
                          classes={{ padding: "0px 16px" }}
                          align="center"
                        >
                          {transferDetail.quantity ?? "-"}
                        </TableCell>
                      </TableRow>
                    </>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          </div>

          <div className="transfer__note_modalfooter">
            <div
              className="transfer__note_modalreset"
              onClick={() => setOpen(false)}
            >
              {t("common:actions.close")}
            </div>
          </div>
        </div>
      </Modal>
    </>
  );
};

export default TransferNoteDetails;
